"use client";

import Link from "next/link";
import useUtility from "@/app/_hooks/useUtility";
import { useSection } from "./_hooks/useSection";
import AppDownloadSkeleton from "./_skeletons/AppDownloadSkeleton";
import Image from "next/image";
import { motion } from "framer-motion";

export const AppDownload = () => {
  const { trans } = useUtility();
  const { content, loading } = useSection("app_download");

  if (loading) {
    return <AppDownloadSkeleton />;
  }

  // Image URLs
  const leftGraphic = content?.left_graphic
    ? `${process.env.NEXT_PUBLIC_API_URL}/assets/images/frontend/app_download/${content.left_graphic}`
    : null;

  const rightPhone = content?.right_phone
    ? `${process.env.NEXT_PUBLIC_API_URL}/assets/images/frontend/app_download/${content.right_phone}`
    : null;

  const playStoreButton = content?.play_store_button
    ? `${process.env.NEXT_PUBLIC_API_URL}/assets/images/frontend/app_download/${content.play_store_button}`
    : "/assets/images/thumbs/play-store.png"; // Default fallback

  const appStoreButton = content?.app_store_button
    ? `${process.env.NEXT_PUBLIC_API_URL}/assets/images/frontend/app_download/${content.app_store_button}`
    : "/assets/images/thumbs/app-store.png"; // Default fallback

  // Store links
  const playStoreLink = content?.play_store_link || "#";
  const appStoreLink = content?.app_store_link || "#";

  return (
    <motion.section
      className="download-app-section"
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.7 }}
    >
      {/* Background Shapes */}
      {leftGraphic && (
        <motion.span
          className="download-app-shape"
          initial={{ opacity: 0, x: -40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.1 }}
        >
          <Image
            src={leftGraphic}
            alt="Left Graphic"
            width={273}
            height={343}
          />
        </motion.span>
      )}
      {rightPhone && (
        <motion.span
          className="download-app-thumb"
          initial={{ opacity: 0, x: 40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.2 }}
        >
          <Image src={rightPhone} alt="Right Phone" width={471} height={352} />
        </motion.span>
      )}

      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-6">
            <motion.div
              className="download-app-content text-center"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7, delay: 0.3 }}
            >
              <motion.h4
                className="download-app-content__title gradient-text"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.7, delay: 0.4 }}
              >
                {trans(content?.heading)}
              </motion.h4>
              <motion.p
                className="download-app-content__desc"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.7, delay: 0.5 }}
              >
                {trans(content?.description)}
              </motion.p>
              <motion.div
                className="download-app-content__buttons"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.7, delay: 0.6 }}
              >
                <Link
                  href={appStoreLink}
                  className="download-app-content__buttons-item"
                  onClick={(e) => {
                    e.preventDefault();
                    window.open(appStoreLink, "_blank", "noopener,noreferrer");
                  }}
                >
                  <Image
                    src="https://res.cloudinary.com/dpkn1ppzj/image/upload/v1752696902/Group_239851_n7jq84.png"
                    alt="App Store"
                    width={129}
                    height={42}
                  />
                </Link>

                <Link
                  href={playStoreLink}
                  className="download-app-content__buttons-item"
                  onClick={(e) => {
                    e.preventDefault();
                    window.open(playStoreLink, "_blank", "noopener,noreferrer");
                  }}
                >
                  <Image
                    src="https://res.cloudinary.com/dpkn1ppzj/image/upload/v1752696837/Group_239851_ebj9en.png"
                    alt="Play Store"
                    width={129}
                    height={42}
                  />
                </Link>
              </motion.div>
            </motion.div>
          </div>
        </div>
      </div>
    </motion.section>
  );
};
